import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import th from "./locales/th.json";
import en from "./locales/en.json";
import lo from "./locales/lo.json";
import zh from "./locales/zh.json";
import vi from "./locales/vi.json";

const savedLanguage = localStorage.getItem("language") || "th";

i18n.use(initReactI18next).init({
  resources: {
    th: { translation: th },
    en: { translation: en },
    lo: { translation: lo },
    zh: { translation: zh },
    vi: { translation: vi },
  },
  lng: savedLanguage,
  fallbackLng: "th",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
